import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "relative mx-auto max-w-7xl" }
const _hoisted_2 = { class: "mx-auto max-w-2xl lg:mx-0 lg:max-w-xl" }
const _hoisted_3 = { class: "mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-10 sm:mt-20 sm:grid-cols-2 sm:gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-4" }
const _hoisted_4 = { class: "text-sm/6 opacity-70" }
const _hoisted_5 = { class: "order-first text-3xl font-semibold tracking-tight" }

import { computed } from "vue";
import EditableElement from "@/views/page/EditableElement.vue";
import type { Stats4Props } from "./stats4Props";
import { PageBlock } from "@/views/blocks/PageBlock.interface";
import type { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import Image from "@/views/blocks/shared/section/image/Image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'stats4',
  props: {
    block: {},
    pageColors: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    "background-color": styleValues.value.background,
    class: "relative isolate overflow-hidden"
  }, {
    default: _withCtx(() => [
      (!dataValues.value.backgroundImage.isHidden)
        ? (_openBlock(), _createBlock(Image, {
            key: 0,
            src: dataValues.value.backgroundImage.data.src,
            alt: "",
            style: _normalizeStyle({
                opacity: dataValues.value.backgroundImage.data.transparency / 100,
            }),
            class: "absolute inset-0 -z-10 size-full object-cover mix-blend-multiply"
          }, null, 8, ["src", "style"]))
        : _createCommentVNode("", true),
      _createVNode(FullSpacing, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (!dataValues.value.topLabel.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    "block-id": _ctx.block.id,
                    "field-name": "topLabel"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Heading, {
                        text: dataValues.value.topLabel.data.text,
                        tag: dataValues.value.topLabel.data.tag,
                        "text-color": styleValues.value.text,
                        class: "text-base/8 opacity-70"
                      }, null, 8, ["text", "tag", "text-color"])
                    ]),
                    _: 1
                  }, 8, ["block-id"]))
                : _createCommentVNode("", true),
              (!dataValues.value.title.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 1,
                    "block-id": _ctx.block.id,
                    "field-name": "title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Heading, {
                        text: dataValues.value.title.data.text,
                        tag: dataValues.value.title.data.tag,
                        "text-color": styleValues.value.text,
                        class: "mt-2 text-4xl sm:text-5xl"
                      }, null, 8, ["text", "tag", "text-color"])
                    ]),
                    _: 1
                  }, 8, ["block-id"]))
                : _createCommentVNode("", true),
              (!dataValues.value.subtitle.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 2,
                    "block-id": _ctx.block.id,
                    "field-name": "subtitle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Paragraph, {
                        text: dataValues.value.subtitle.data.text,
                        "text-color": styleValues.value.text,
                        class: "mt-6 text-lg/8 opacity-70"
                      }, null, 8, ["text", "text-color"])
                    ]),
                    _: 1
                  }, 8, ["block-id"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("dl", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.stats.data.items, (stat) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-col gap-y-3 border-l pl-6",
                  key: `stat${stat.id}`,
                  style: _normalizeStyle({
                            color: styleValues.value.text,
                            borderColor: styleValues.value.border,
                        })
                }, [
                  _createVNode(EditableElement, {
                    "block-id": _ctx.block.id,
                    "field-name": `stats_${stat.id}`,
                    hideable: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("dt", _hoisted_4, _toDisplayString(stat.statDesc), 1),
                      _createElementVNode("dd", _hoisted_5, _toDisplayString(stat.statTitle), 1)
                    ]),
                    _: 2
                  }, 1032, ["block-id", "field-name"])
                ], 4))
              }), 128))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "background-color"]))
}
}

})